import { LocationDTO } from '@sales-center/common'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function useSelectLocationsWithServices(
  serviceLocations: LocationDTO[],
  localMode: boolean,
): LocationDTO[] {
  const services = useSelector(selectAllLeadOppProducts)

  return useMemo(
    () =>
      serviceLocations.filter((location) => {
        const locationSearchId = localMode
          ? location.externalLinkId ?? ''
          : location.id.toString()

        return (
          services.findIndex(
            (service) => service.serviceLocationId == locationSearchId,
          ) >= 0
        )
      }),
    [localMode, serviceLocations, services],
  )
}
